// Based on https://cdn.rawgit.com/WICG/ResizeObserver/351d5d40/examples/iframeResize.js

const $ = jQuery;

export function iframeResize() {
  if ( window === window.parent ) {
    setupWindow();
  } else {
    setupIframe();
  }
}

export function computeIdealSize( isImage = false ) {
  if ( isImage ) {
    let imageSize = document.querySelector( 'img' )!.getBoundingClientRect();
    return { width: imageSize.width, height: imageSize.height };
  }

  const scrollRoot = document.scrollingElement as HTMLElement;

  // Handle text sizing
  // hide scrollbars before measuring ideal size
  let saveOverflow = scrollRoot.style.overflow;
  scrollRoot.style.overflow = "hidden";

  let idealWidth, idealHeight;
  if ( document.body.scrollWidth > window.innerWidth ) {
    // If document is wider than iframe, resize to scroll width
    idealWidth = scrollRoot.scrollWidth;
  } else {
    // Document is narrower, resize to offset width
    idealWidth = scrollRoot.offsetWidth;
  }
  if ( document.body.scrollHeight > window.innerHeight ) {
    // document is taller than iframe, resize to scroll height
    idealHeight = scrollRoot.scrollHeight;
  } else {
    idealHeight = scrollRoot.offsetHeight;
  }
  scrollRoot.style.overflow = saveOverflow;
  return { width: idealWidth, height: idealHeight };
}

// isImage should be true if iframe is being sized to an image.
export function setupIframe( isImage = false ) {
  if ( !window.ResizeObserver ) {
    return;
  }
  let ro = new ResizeObserver( entries => {
    let idealSize = computeIdealSize( isImage );
    window.parent.postMessage( {
      name: "iframeResize",
      width: idealSize.width,
      height: idealSize.height
    }, '*' );
  } );
  ro.observe( document.body );
  // Prevent scrollbar flash
  ( document.scrollingElement as HTMLElement ).style.overflow = 'hidden';
}

export function findEventSourceIframe( eventSource: MessageEventSource ) {
  let frames = Array.from( document.querySelectorAll( 'iframe' ) );
  for ( let iframe of frames ) {
    if ( iframe.contentWindow === eventSource ) {
      return iframe;
    }
  }
}

export function setupWindow() {
  window.addEventListener( "message", ev => {
    if ( ev.data && ev.source && ev.data.name === "iframeResize" ) {
      let iframe = findEventSourceIframe( ev.source );
      if ( iframe ) {
        iframe.style.width = ev.data.width + "px";
        iframe.style.height = ev.data.height + "px";
      }
    }
  }, false );
}

export function loadInFrame() {

  // Only run in the top-level
  if ( window !== window.parent ) { return; }

  // Set custom loader element
  const customLoader = $( '#loadFrame .custom-loader' );

  $( '#loadFrame' ).on( {

    // Empty Load Frame iframe when closed
    [ 'hidden.bs.modal' ]( e ) {
      $( '#loadFrame .modal-body iframe' ).remove();
    },

  } );

  const clickHandler = function ( this: HTMLLinkElement, e: JQueryEventObject ) {

    const url = new URL( this.href );

    // Ignore external URLs
    if ( url.hostname !== location.hostname ) { return; }

    // Prevent the click now that we know we should handle this URL
    e.preventDefault();

    // Fade out the existing iframe (if it exists) and remove it
    $( '#loadFrame .modal-body iframe' )
      .fadeTo( 400, 0, function ( this: HTMLIFrameElement ) {
        $( this ).remove();
      } );

    customLoader.show();

    const queryParams = new URLSearchParams( url.search );
    queryParams.set( 'ajax', '1' );

    const $iframe = $( '<iframe>', {
      src: url.pathname + '?' + queryParams,
      allowtransparency: true,
      style: 'border: none; opacity: 0;',
    } );
    const iframe = $iframe.get( 0 ) as HTMLIFrameElement;

    $iframe.appendTo( '#loadFrame .modal-body' );

    // We can get the iframe's window only after it has been attached to the DOM
    const iframeWindow = iframe.contentWindow!;

    iframeWindow.addEventListener( 'DOMContentLoaded', e => {

      // Get a reference to the iframe's jQuery instance
      const i$ = ( iframeWindow as any ).jQuery as JQueryStatic;

      // Get a fresh reference each time, because the $iframe var from the parent scope gets destroyed.
      const $iframe = $( '#loadFrame .modal-body iframe' );

      customLoader.hide();

      $iframe.fadeTo( 400, 1 );

      i$( 'body' ).on( 'click', '[data-frame-load]', clickHandler );

      i$( 'body' ).on( 'click', 'a, button, form', function ( this: HTMLLinkElement | HTMLButtonElement | HTMLFormElement, e ) {
        i$( this ).attr( 'target', '_top' );
      } );

      // Helper method to pass iframe events to the parent window
      const bubbleEventToTop = ( selector: string, eventName: string ) => {
        i$( selector ).on( eventName, ( e, ...args ) => {
          $( selector ).trigger( eventName, args );
        } );
      };

      bubbleEventToTop( 'body', 'adding_to_cart' );
      bubbleEventToTop( 'body', 'added_to_cart' );

    } );

    // Everything is ready
    $( '#loadFrame' ).modal( 'show' );

  };

  $( 'body' ).on( 'click', '[data-frame-load]', clickHandler );

}
